import { useMutation, useQueryClient } from '@tanstack/react-query';

import ReservationService from '~/services/ReservationService';

import { propertyQueryKeys } from './useGetProperty';

interface UpdatePropertyLogoParams {
  logoId: string | null;
  propertyId: string;
}

export function useUpdatePropertyLogo() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ propertyId, logoId }: UpdatePropertyLogoParams) =>
      ReservationService.patchProperty(
        {
          logo_id_cloudinary_external: logoId,
        },
        propertyId,
      ),
    onSuccess: (_data, { propertyId }) => {
      queryClient.invalidateQueries({ queryKey: propertyQueryKeys.detail(propertyId) });
    },
  });
}
